import { Group } from "../devices/types";

import { expandGroupIdsWithDescendants, getGroupDepth } from "./utils";

export type GroupDropState = "allowed" | "notAllowed" | "unchanged";

type GroupDropRules = {
    groups: Group[];
    canUpdate: (groupId: number) => boolean;
    nestingLimit: number;
};

export const getGroupDropState = (
    draggedId: number,
    targetId: number | null,
    { groups, canUpdate, nestingLimit }: GroupDropRules,
): GroupDropState => {
    const dragged = groups.find((group) => group.id === draggedId);
    if (!dragged) {
        return "notAllowed";
    }
    if (targetId === dragged.parentId) {
        return "unchanged";
    }
    if (targetId === null) {
        return "allowed";
    }
    // A group cannot move into its own subtree: that would make it its own ancestor.
    if (expandGroupIdsWithDescendants([draggedId], groups).includes(targetId)) {
        return "notAllowed";
    }
    // The target's members gain access to the moved group, so the user must be allowed to change the target too.
    if (!canUpdate(targetId)) {
        return "notAllowed";
    }
    if (getGroupDepth(targetId, groups) >= nestingLimit) {
        return "notAllowed";
    }
    return "allowed";
};

export const canOfferTopLevelDrop = (draggedId: number, groups: Group[]) =>
    (groups.find((group) => group.id === draggedId)?.parentId ?? null) !== null;
